import { IFormPartnerDetails } from 'legacy/lut/classes/models/IFormCompanyDetails'
import { metalocatorCategoriesApi } from 'legacy/lut/classes/services/api/MetalocatorCategoriesApi'
import { read, save } from 'legacy/lut/store'
import { StoreForms } from 'legacy/lut/store/state'

import { IFetchResult } from 'core/classes/helpers/store/Interfaces'
import { HttpCancel } from 'core/classes/http'

class CompanyStoreService {
  public async setCategoryInfo(partner: IFormPartnerDetails) {
    if (partner.TagIdList === '') {
      return partner
    }
    const idArray = partner.TagIdList.replace(/\s/g, '').split(',')
    const categories: any = await this.getCategories()
    const categoryFields = [
      'PaymentTypes',
      'Specialization',
      'AreasOfFocus',
      'SpecializedIn',
      'Software',
      'Other',
    ]
    for (const field of categoryFields) {
      partner[field] = []
      const categoryArray =
        (categories &&
          categories
            .filter(
              (item: any) => item.tag_group.replace(/\s/g, '').toLowerCase() === field.toLowerCase()
            )
            .sort((a: any, b: any) => a.id - b.id)) ||
        []
      if (categoryArray && categoryArray.length > 0) {
        for (const id of idArray) {
          const item = categoryArray.find((item: any) => item.id === parseInt(id, 10))
          item && partner[field].push(item)
        }
      }
    }
    return partner
  }

  public getCategories = async (
    isForced = false,
    cancelObject?: HttpCancel
  ): Promise<IFetchResult<any>> => {
    let result = !isForced
      ? read(StoreForms.metalocatorCategories, 'metalocatorCategories_cache')
      : null
    if (!result) {
      result = await metalocatorCategoriesApi.fetchCategories(cancelObject)
      save(StoreForms.metalocatorCategories, 'metalocatorCategories_cache', result)
    }
    return {
      items: result.items || [],
      total: 0,
    }
  }
}

export const companyStoreService = new CompanyStoreService()
